import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Divider, List, ListItem, ListItemText } from '@mui/material';

import { Loader } from 'ui';
import { EmptyDataLabel } from 'ui/Labels';

const SimpleDataList = ({ data, loading, onItemClick, emptyText }) => (
  <Paper>
    {loading ? (
      <Box py={1}>
        <Loader center />
      </Box>
    ) : (
      <List>
        {data.map((item, index) => {
          const { id, primaryText, secondaryText } = item;

          return (
            <React.Fragment key={id}>
              <ListItem button onClick={() => onItemClick(item)}>
                <ListItemText primary={primaryText} secondary={secondaryText} />
              </ListItem>
              {index + 1 < data.length && <Divider />}
            </React.Fragment>
          );
        })}
        {!loading && data.length === 0 && <EmptyDataLabel label={emptyText} />}
      </List>
    )}
  </Paper>
);

SimpleDataList.defaultProps = {
  loading: false,
  onItemClick: () => null,
};

SimpleDataList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      primaryText: PropTypes.string.isRequired,
      secondaryText: PropTypes.string,
    }),
  ).isRequired,
  loading: PropTypes.bool,
  onItemClick: PropTypes.func,
  emptyText: PropTypes.string.isRequired,
};

export default SimpleDataList;
